"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoEnumTypeMismatch = void 0;
const utils_1 = require("../utils");
exports.NoEnumTypeMismatch = () => {
    return {
        Schema(schema, { report, location }) {
            if (schema.enum && schema.type) {
                const typeMismatchedValues = schema.enum.filter((item) => !utils_1.matchesJsonSchemaType(item, schema.type, schema.nullable));
                for (const mismatchedValue of typeMismatchedValues) {
                    report({
                        message: `All values of \`enum\` field must be of the same type as the \`type\` field: expected "${schema.type}" but received "${utils_1.oasTypeOf(mismatchedValue)}".`,
                        location: location.child(['enum', schema.enum.indexOf(mismatchedValue)]),
                    });
                }
            }
        },
    };
};
